"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _styles = require("@material-ui/core/styles");

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _clsx2 = _interopRequireDefault(require("clsx"));

var _Log = require("../Log");

var _styles2 = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Button(_ref) {
  var _clsx;

  var classNameProp = _ref.className,
      children = _ref.children,
      onClick = _ref.onClick,
      type = _ref.type,
      buttonType = _ref.buttonType,
      isLoading = _ref.isLoading,
      disabled = _ref.disabled,
      classes = _ref.classes,
      logEventProps = _ref.logEventProps,
      rest = _objectWithoutProperties(_ref, ["className", "children", "onClick", "type", "buttonType", "isLoading", "disabled", "classes", "logEventProps"]);

  var btnClassName = (0, _clsx2["default"])((_clsx = {}, _defineProperty(_clsx, classes.button, true), _defineProperty(_clsx, classes.text, type === "TEXT"), _defineProperty(_clsx, classes["default"], type === "DEFAULT"), _defineProperty(_clsx, classes.primary, type === "PRIMARY"), _defineProperty(_clsx, classes.outlined, type === "OUTLINED"), _defineProperty(_clsx, classes.underlined, type === "UNDERLINED"), _defineProperty(_clsx, classes.isLoading, isLoading), _defineProperty(_clsx, classes.disabled, !isLoading && disabled), _defineProperty(_clsx, classNameProp, classNameProp), _clsx));
  return _react["default"].createElement(_Log.LogEvent, {
    logEventProps: logEventProps,
    actionProps: {
      onClick: {
        action: 'click'
      }
    }
  }, _react["default"].createElement(_Button["default"], _extends({
    variant: type === "TEXT" ? "text" : "contained",
    onClick: onClick,
    className: btnClassName,
    type: buttonType
  }, rest), children, isLoading && _react["default"].createElement(_CircularProgress["default"], {
    className: classes.loader,
    size: 15,
    thickness: 3
  })));
}

Button.defaultProps = {
  className: "",
  children: "",
  type: "DEFAULT",
  onClick: function onClick() {
    return 0;
  },
  buttonType: "button",
  isLoading: false,
  disabled: false
};
Button.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  onClick: _propTypes["default"].func,
  type: _propTypes["default"].oneOf(["DEFAULT", "PRIMARY", "OUTLINED", "TEXT", "UNDERLINED"]),
  buttonType: _propTypes["default"].oneOf(["button", "submit"]),
  isLoading: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool
};

var _default = (0, _styles.withStyles)(_styles2["default"])(Button);

exports["default"] = _default;